import type { DoorConfig } from '@/lib/configurator/options'

import { DEFAULT_CONFIG } from '@/lib/configurator/options'
import { normalizeConfig } from '@/lib/configurator/validate'

export interface CuratedDesign {
    slug: string
    name: string
    room: string
    description: string
    config: DoorConfig
}

const design = (overrides: Partial<DoorConfig>): DoorConfig => normalizeConfig({ ...DEFAULT_CONFIG, ...overrides })

export const CURATED_DESIGNS: CuratedDesign[] = [
    {
        slug: 'herenhuis-bovenlicht',
        name: 'Herenhuis',
        room: 'Hal en trappenhuis',
        description: "Klassieke vakverdeling met een glazen bovenlicht en een zwarte deurkruk. Brengt daglicht diep de hal in, precies zoals in een oud grachtenpand.",
        config: design({ doorType: 'draaideur', width: 930, height: 2315, division: 'herenhuis', glass: 'helder', finish: 'ral9005', profile: 'klassiek', handle: 'kruk', handleFinish: 'zwart', transom: true, transomHeight: 450 })
    },
    {
        slug: 'atelier-ribbel',
        name: 'Atelier Ribbel',
        room: 'Woonkamer en keuken',
        description: "Een taatsdeur met atelierverdeling en ribbelglas op aanvraag. Zachte privacy, veel licht en een zwarte greep over de volle lengte.",
        config: design({ doorType: 'taatsdeur', width: 1000, height: 2400, division: 'raster', rows: 4, cols: 1, glass: 'op-aanvraag', glassNote: 'Ribbelglas', finish: 'ral9005', profile: 'slank', handle: 'lang', handleFinish: 'zwart' })
    },
    {
        slug: 'bauhaus-antraciet',
        name: 'Bauhaus Antraciet',
        room: 'Werkkamer',
        description: "Ladders aan weerszijden van een groot open vlak, in antraciet RAL 7016 met matglas. Rustig, grafisch en tijdloos.",
        config: design({ doorType: 'draaideur', width: 960, height: 2400, division: 'bauhaus', glass: 'mat', finish: 'ral', ralCode: 'RAL 7016', profile: 'slank', handle: 'klein', handleFinish: 'zwart' })
    },
    {
        slug: 'loft-duo',
        name: 'Loft Duo',
        room: 'Eetkamer',
        description: "Twee deuren die de woonkamer en eetkamer met elkaar verbinden. Horizontale roeden, lange zwarte grepen en een doorlopend bovenlicht.",
        config: design({ doorType: 'dubbele-draaideur', width: 1600, height: 2315, division: 'horizontaal', rows: 3, glass: 'helder', finish: 'ral9005', profile: 'slank', handle: 'lang', handleFinish: 'zwart', transom: true, transomHeight: 400 })
    },
    {
        slug: 'art-deco-groen',
        name: 'Art deco',
        room: 'Salon',
        description: "Een royale taatsdeur in dennengroen RAL 6009 met art-decovakken boven en onder. Helder glas laat het interieur stralen.",
        config: design({ doorType: 'taatsdeur', width: 1100, height: 2600, division: 'artdeco', glass: 'helder', finish: 'ral', ralCode: 'RAL 6009', profile: 'slank', handle: 'lang', handleFinish: 'messing' })
    },
    {
        slug: 'minimal-schuifdeur',
        name: 'Minimal',
        room: 'Slaapkamer en badkamer',
        description: "Een strakke schuifdeur met matglas aan een zichtbare stalen rail. Privacy waar u die wilt, en geruisloos dicht dankzij soft-close.",
        config: design({ doorType: 'schuifdeur', width: 1000, height: 2315, division: 'strak', glass: 'mat', finish: 'ral9005', profile: 'slank', handle: 'klein', handleFinish: 'zwart', softClose: true })
    },
    {
        slug: 'hal-zijlichten',
        name: 'Entree met zijlichten',
        room: 'Entree',
        description: "Een draaideur met twee vaste zijpanelen in matglas. Maakt van een smalle gang een lichte, uitnodigende entree.",
        config: design({ doorType: 'draaideur', width: 930, height: 2315, division: 'horizontaal', rows: 3, glass: 'mat', finish: 'ral9005', profile: 'klassiek', handle: 'kruk', handleFinish: 'rvs', sidePanels: 'beide', sidePanelWidth: 400 })
    },
    {
        slug: 'verticaal-wit',
        name: 'Scandinavisch',
        room: 'Kinderkamer en speelkamer',
        description: "Wit staal in RAL 9016 met verticale lijnen en een dicht onderpaneel. Licht van uitstraling en praktisch in gebruik.",
        config: design({ doorType: 'draaideur', width: 880, height: 2315, division: 'verticaal', cols: 2, glass: 'helder', finish: 'ral9016', profile: 'klassiek', handle: 'vaste-kruk', handleFinish: 'zwart', bottomPanel: true })
    }
]
